import {BotIcon, LayoutGridIcon} from "lucide-react";

import {Card, CardContent} from "@components/ui/card";

interface PlaceholderTabProps {
    workspaceId: string;
    scenarioId: string;
    actualMonths?: number;
    forecastMonths?: number;
    /** The tab label from the backend, e.g. "KPIs", "Board Report" */
    label?: string;
}

/**
 * Generic placeholder for tabs that don't have a custom component yet.
 * Shown when the backend registers a tab key that the frontend hasn't
 * built a dedicated component for. Encourages the user to interact
 * with the AI agent to populate the tab.
 */
export function PlaceholderTab({label}: PlaceholderTabProps) {
    return (
        <div className="flex-1 overflow-y-auto pb-8">
            <Card>
                <CardContent className="flex flex-col items-center justify-center py-16 text-center space-y-4">
                    <LayoutGridIcon className="size-10 text-muted-foreground/40" />
                    <div className="space-y-1">
                        <h3 className="text-lg font-semibold">{label ?? "New Tab"}</h3>
                        <p className="text-sm text-muted-foreground max-w-md">
                            This tab is being set up. Use the AI agent to populate it with reports and analysis.
                        </p>
                    </div>
                    <div className="flex items-center gap-2 rounded-lg border border-dashed px-4 py-3 text-sm text-muted-foreground">
                        <BotIcon className="size-4 text-[#209DB3]" />
                        <span>
                            Try asking: <em className="text-foreground">"Generate a {label?.toLowerCase() ?? "report"} for this workspace"</em>
                        </span>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
